import { styled } from '@linaria/react';
import { bodyFont, fonts, layout, semantic, space } from '../../theme/tokens';

export const FilterContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: flex-start;
  gap: ${space[4]};
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: auto auto;
    justify-content: flex-end;
    align-items: center;
    gap: ${space[3]};
  }
`;

export const CategoryDropdownContainer = styled.div`
  width: 100%;
`;

export const ToggleContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const GroupsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[6]};
`;

export const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[4]};
  margin-bottom: ${space[4]};
`;

export const GroupHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex-shrink: 0;
`;

export const GroupLabel = styled.h3`
  font-family: ${bodyFont};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  margin: 0;
  line-height: 1.3;
`;

export const GroupSubLabel = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  line-height: 1.3;
`;

export const GroupRule = styled.span`
  flex: 1;
  height: 1px;
  background: ${semantic.bg.surfaceSubtle};
`;

export const CompactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space[4]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
